import { sharedAxios } from '@api/api-config';

export interface AdminSessionDto {
  sessionId: string;
  userId: number;
  email: string | null;
  firstName: string | null;
  familyName: string | null;
  createdAt: string;
  lastAccessedAt: string;
  expiresAt: string;
  ipAddress: string | null;
  userAgent: string | null;
  rememberMe: boolean;
}

export interface AdminSessionListResponse {
  sessions: AdminSessionDto[];
  totalCount: number;
}

const BASE = '/bff/api/admin/sessions';

export const adminSessionApi = {
  getAdminSessionList: () => sharedAxios.get<AdminSessionListResponse>(BASE),

  deleteAdminSession: (sessionId: string) => sharedAxios.delete<Record<string, string>>(`${BASE}/${sessionId}`),

  deleteAdminUserSessions: (userId: number) => sharedAxios.delete<Record<string, string>>(`${BASE}/user/${userId}`),
};
